import * as DateF from 'date-fns'
import styled from 'styled-components'

import { DATE_FORMAT } from '@root/shared'

type SupportConversationItemReplyProps = {
  text: string
  createdAt: Date
  withCorner?: boolean
  isMyReply?: boolean
}

export const SupportConversationItemReply: React.FC<
  SupportConversationItemReplyProps
> = ({ text, createdAt, withCorner = false, isMyReply = false }) => {
  if (isMyReply) {
    return (
      <MyReply>
        <Text>{text}</Text>
        <DateTime>
          {DateF.format(createdAt, DATE_FORMAT.MMMM_d__HH_mm_ss)}
        </DateTime>
        {withCorner ? <ReplyCorner color="var(--backgroundA-2)" /> : undefined}
      </MyReply>
    )
  }

  return (
    <OtherReply>
      <Text>{text}</Text>
      <DateTime>
        {DateF.format(createdAt, DATE_FORMAT.MMMM_d__HH_mm_ss)}
      </DateTime>
      {withCorner ? <ReplyCorner color="var(--backgroundA-3)" /> : undefined}
    </OtherReply>
  )
}

const OtherReply = styled.div`
  color: var(--text-12);
  background: var(--backgroundA-3);

  border-radius: 10px;
  padding: 10px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  justify-self: start;
`

const MyReply = styled(OtherReply)`
  color: var(--text-11);
  background: var(--backgroundA-2);
  border-radius: 10px 10px 0 10px;
  position: relative;

  justify-self: end;
`

const ReplyCorner = ({ color }: { color: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="5"
      height="7"
      viewBox="0 0 5 7"
      style={{
        position: 'absolute',
        bottom: '-0.5px',
        right: '-4.5px',
      }}
    >
      <path d="M5 6.5H0V0C0 3.6 3.33333 5.83333 5 6.5Z" fill={color} />
    </svg>
  )
}

const Text = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`

const DateTime = styled.div`
  color: var(--text-7);
  text-align: right;

  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`
